<script>
    import {createEventDispatcher} from 'svelte';

    import Caja from "../../UI/Caja.svelte";
    import {url} from '@sveltech/routify';

    import Boton from "../../UI/Boton.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Icono from "../Icono.svelte";

    export let motivo;

    const dispatch = createEventDispatcher();

    const eliminarMotivo = () => dispatch('eliminar-motivo', motivo);
</script>

<style>
    .acciones {
        text-align: right;
    }

    .titulo {
        display: flex;
        align-items: flex-end;
        align-items: center;
    }

    .horario strong {
        font-weight: 500;
    }
</style>

<div class="tipoDeJornada">
    <Caja>
        <div slot="titulo" class="titulo">
            <Icono {motivo}/>
            <Subtitulo>{motivo.nombre}</Subtitulo>
        </div>

        <div class="tipo">
            {motivo.tipo}
            {#if motivo.codigo}
                <br><strong>Código telefónico:</strong> {motivo.codigo}
            {/if}
        </div>

        <div slot="pie" class="acciones">
            {#if !motivo.protegido}
                <Boton href={$url(`/motivos/${motivo.id}`)} icono="edit" tipo="ok">
                    Editar
                </Boton>

                <Boton on:click={eliminarMotivo} icono="delete" tipo="peligro">Borrar</Boton>
            {/if}
        </div>
    </Caja>
</div>